
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsTruckDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2,
  transform: "translate(0 2)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 6.707,
  cy: 22.451,
  r: 2.431
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.293,
  cy: 22.451,
  r: 2.431
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.724 22.45h3.64v-7.292l-1.91-7.89a2.416 2.416 0 0 0-2.418-1.833h-4.174V22.45m-9.724.001h9.724v-6.084H.636v6.084h3.64M.636.573h18.226v15.794H.636z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.862 12.727h2.431l2.431 2.431h3.64"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 28 28\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\" transform=\"translate(0 2)\">\r\n            <circle cx=\"6.707\" cy=\"22.451\" r=\"2.431\"/>\r\n            <circle cx=\"21.293\" cy=\"22.451\" r=\"2.431\"/>\r\n            <path d=\"M23.724 22.45h3.64v-7.292l-1.91-7.89c-.274-1.104-1.28-1.867-2.418-1.833h-4.174V22.45M9.138 22.451L18.862 22.451 18.862 16.367.636 16.367.636 22.451 4.276 22.451M.636.573L18.862.573 18.862 16.367.636 16.367z\"/>\r\n            <path d=\"M18.862 12.727L21.293 12.727 23.724 15.158 27.364 15.158\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-truck-delivery.7e17fbd51293e7ee9de7a8f08fc26f3a.svg"),
        {
          React: SvgIconsTruckDelivery,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      